<template>
  <div>
    <h2
      v-if="title"
      class="title title--2 center"
    >
      {{ title }}
    </h2>

    <h2
      v-if="subtitle"
      class="title title--6 center"
    >
      {{ subtitle }}
    </h2>

    <div class="flex justify-center gap">
      <a
        v-if="merchant.features.aosUrl"
        :href="merchant.features.aosUrl"
        target="_blank"
      >
        <img
          style="height: var(--input-height)"
          src="/images/google-play-badge.svg"
          alt="Google Play Badge"
        >
      </a>

      <a
        v-if="merchant.features.iosUrl"
        :href="merchant.features.iosUrl"
        target="_blank"
      >
        <img
          style="height: var(--input-height)"
          src="/images/app-store-dark.svg"
          alt="App Store Badge"
        >
      </a>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'AppDownloadBadges',

    props: {
      title: {
        type: String,
        default: ''
      },

      subtitle: {
        type: String,
        default: ''
      }
    },

    computed: {
      ...mapGetters('merchant', ['merchant'])
    }
  };
</script>
